export default {
  title: {
    id: 'select_your_orderline_title',
    defaultMessage: 'Select your order',
  },
  infoBlockTitle: {
    id: 'select_your_orderline_info_block_title',
    defaultMessage: 'Make sure you select the right item!',
  },
  infoBlockDescription: {
    id: 'select_your_orderline_info_block_description',
    defaultMessage:
      'Selecting the right item ensures you connect with the right agent and seller.',
  },
  myOrders: {
    id: 'dashboard_menu_orders',
    defaultMessage: 'My orders',
  },
  breadcrumb: {
    id: 'breadcrumb_aria_label',
    defaultMessage: 'Breadcrumb',
  },
}
